import clsx from 'clsx'
import {uniq} from 'lodash'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'

export default function SubjectFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {myCourses: courses, translate} = context
  const mySubjects = uniq(courses.map(({course}) => course.substring(0,2)))
  const subjects = context.subjects.filter(({id}) => mySubjects.indexOf(id) >= 0)

  return (
    <ClearableSelect
      id="question-bank-subject-filter"
      className={clsx(classes.select, "subject")}
      value={context.query.subject || ""}
      caption={translate('subject_label')}
      onChange={onChange}
    >
      {subjects.map((subject, key) => (<MenuItem value={subject.id} key={key}>{subject.name}</MenuItem>))}
    </ClearableSelect>
  )
}
